export default __webpack_public_path__ + "static/media/area-33.cf7efad8.jpg";